import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LeadGenDetailShell } from "@/features/lead-gen/components/LeadGenDetailShell";
import { TemplateEditorForm } from "@/features/lead-gen/components/TemplateEditorForm";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/templates/new")({
    component: NewLeadTemplatePage,
});

function NewLeadTemplatePage() {
    const { setTemplates, artifacts } = useLeadGen();
    const navigate = useNavigate();

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Templates", route: { to: "/sales/leads/templates" } },
        { label: "New", route: { to: "/sales/leads/templates/new" } },
    ]);

    return (
        <LeadGenDetailShell
            backTo="/sales/leads/templates"
            backLabel="All templates"
            summary={
                <p className="text-slate-500 text-sm">
                    Define instructions and attach artefacts from the library. Timing is used when adding leads.
                </p>
            }
        >
            <TemplateEditorForm
                template={null}
                artifacts={artifacts}
                onCancel={() => void navigate({ to: "/sales/leads/templates" })}
                onSave={(next) => {
                    setTemplates((current) => {
                        const merged = [...current, next];
                        return next.is_default
                            ? merged.map((template) => ({
                                  ...template,
                                  is_default: template.id === next.id,
                              }))
                            : merged;
                    });
                    void navigate({
                        to: "/sales/leads/templates/$templateId",
                        params: { templateId: next.id },
                    });
                }}
            />
        </LeadGenDetailShell>
    );
}
